export function isBackgroundWhite(payload: string[]) {
    if (Array.isArray(payload)) {
      const path = window.location.pathname;
      const isMatch = payload.some(element => path.includes(element));
      return isMatch;
    }
    return false; 
  }
